import {Component, OnInit, OnDestroy} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';

@Component({
        standalone: false,
        // tslint:disable-next-line:component-selector
        selector: 'app-unauthorize',
        templateUrl: './unauthorize-page.component.html',
        styleUrls: ['./unauthorize-page.component.css'],
})
export class UnauthorizeComponent implements OnInit, OnDestroy {

        severity!: string;
        title!: string;
        instructions1!: string;
        instructions2!: string;
        buttonLabel?: string;
        url!: string;
        countdown: number = 1;

        private timer: any;

        constructor(private route: ActivatedRoute, private router: Router) {}

        ngOnInit() {
                this.route.queryParams
                        .subscribe(params => {
                                this.severity = params['severity'];
                                this.title = params['title'];
                                this.instructions1 = params['instructions1'];
                                this.instructions2 = params['instructions2'];
                                this.buttonLabel = params['buttonLabel'];
                                this.url = params['url'];

                                // Auto-redirigir cuando es Acceso Denegado (401)
                                // para evitar que el usuario crea que no tiene acceso
                                // cuando en realidad es un problema de carga de sesión.
                                if (this.title === 'Acceso Denegado') {
                                        this.startCountdown();
                                }
                        });
        }

        private startCountdown(): void {
                this.timer = setInterval(() => {
                        this.countdown--;
                        if (this.countdown <= 0) {
                                clearInterval(this.timer);
                                this.router.navigateByUrl('/');
                        }
                }, 1000);
        }

        goToUrl() {
                const allowedPaths = ['/', '/login', '/home'];
                const safeUrl = allowedPaths.includes(this.url) ? this.url : '/';
                this.router.navigateByUrl(safeUrl);
        }

        ngOnDestroy() {
                if (this.timer) {
                        clearInterval(this.timer);
                }
        }
}